import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { F } from '../../styles/theme';

export default function SectionHeader({ title, action, dense = false }) {
  const { T } = useTheme();
  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'baseline',
        justifyContent: 'space-between',
        padding: dense ? '8px 20px 8px' : '24px 20px 12px',
      }}
    >
      <h2
        style={{
          margin: 0,
          fontFamily: F.family,
          color: T.text,
          fontSize: 13,
          fontWeight: 600,
          textTransform: 'uppercase',
          letterSpacing: '0.08em',
          opacity: 0.62,
        }}
      >
        {title}
      </h2>
      {action}
    </div>
  );
}
